import PropTypes from 'prop-types';

import RadioButton from '#globalComponents/RadioButton/RadioButton';

export default function OptionCard({ name, value, checked, onChange, title, description, disabled = false }) {
	return (
		<div
			className={`rounded-card border p-1 transition-colors ${
				checked ? 'border-primary-500' : 'border-bgBase-500'
			}`}
		>
			<RadioButton
				name={name}
				value={value}
				checked={checked}
				onChange={onChange}
				disabled={disabled}
				label={
					<span className="block">
						<span className="block font-medium">{title}</span>
						{description && (
							<span className="mt-0.5 block text-xs font-normal text-bgBase-800">{description}</span>
						)}
					</span>
				}
			/>
		</div>
	);
}

OptionCard.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	checked: PropTypes.bool.isRequired,
	onChange: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
	description: PropTypes.string,
	disabled: PropTypes.bool,
};
